export default "__VITE_ASSET__KlV9e5$j__"